// @ngInject
Models.SessionsCollection = function SessionsCollection(BaseCollection) {

    return Class(BaseCollection, {
            constructor: function constructor() {
                this.constructor.$super.call(this);
                this._collection.__className = 'SessionsCollection';
                this._collection.__childsType = 'SessionModel';
                this._collection.shouldMergeOnLoad = true;
                return this._collection;
            }
        }
    );
};